/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LicenseCloudConnectStateRepresentation } from './licenseCloudConnectStateRepresentation';
import { LicenseUpdateState } from './licenseUpdateState';
import { CommonLicenseStateRepresentation } from './commonLicenseStateRepresentation';
import { LicenseTypeRepresentation } from './licenseTypeRepresentation';
import { LicensePackageRepresentation } from './licensePackageRepresentation';
import { LicenseEditionRepresentation } from './licenseEditionRepresentation';


export interface VacLicenseInfo { 
    licenseEdition?: LicenseEditionRepresentation;
    licenseType?: LicenseTypeRepresentation;
    licenseTypeString?: string;
    licensePackage?: LicensePackageRepresentation;
    licensePackageString?: string;
    expirationDate?: string | null;
    supportExpirationDate?: string | null;
    isExpired?: boolean;
    isExpiredWithoutGrace?: boolean;
    licUnitsVAW?: number;
    usedUnitsVAW?: number;
    newUnitsVAW?: number;
    productName?: string;
    licenseeCompany?: string;
    edition?: string;
    licenseeLastName?: string;
    licenseeFirstName?: string;
    updateAllowed?: boolean;
    autoUpdate?: boolean;
    usageLoggingMode?: VacLicenseInfoUsageLoggingMode;
    contactPerson?: string;
    status?: string;
    state?: CommonLicenseStateRepresentation;
    cloudConnectProvider?: LicenseCloudConnectStateRepresentation;
    cloudConnectProviderString?: string;
    supportId?: string;
    licenseId?: string;
    lastUpdateStatus?: LicenseUpdateState;
    lastUpdateDate?: string | null;
    lastUpdateMessage?: string;
    instances?: number;
    sockets?: number;
    monitoring?: string;
    orchestration?: string;
    signature?: string;
    licenseeEmail?: string;
    licenseeAdministratorEmail?: string;
}
export enum VacLicenseInfoUsageLoggingMode {
    Disabled = 'disabled',
    AutoUpdate = 'autoUpdate',
    Enabled = 'enabled'
};



